module.exports = __webpack_public_path__ + "static/img/box-close.9542ead2.webp";